import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { makeStyles } from '@material-ui/core/styles';
import useTheme from '@material-ui/core/styles/useTheme';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Spin from 'components/Spin';
import React, { Fragment } from 'react';

import type { ISubscriptions } from 'v2/interfaces/subscriptions';

import CardUsageTable from './cardUsageTable';
import DialogTitle from '../../DialogTitle';
import Transition from '../transition';

export const useStyles = makeStyles((theme) => ({
  dialogContent: {
    padding: '8px 24px',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  noUsageText: {
    padding: '12px 0',
  },
  removeBtn: {
    marginRight: theme.spacing(1),
    backgroundColor: '#dc3f53',
    color: '#fff',
  },
}));

interface IProps {
  isOpen: boolean;
  loading: boolean;
  removing: boolean;
  cardUsage: ISubscriptions[];
  handleClose: () => void;
  onRemove: () => void;
}

const DialogRemoveCard = ({ isOpen, loading, removing, cardUsage, handleClose, onRemove }: IProps) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const classes = useStyles();

  const cardNoUsage = !loading && !cardUsage.length;

  return (
    <Dialog
      TransitionComponent={Transition}
      aria-labelledby='customized-dialog-title'
      open={isOpen}
      fullWidth={true}
      maxWidth={'sm'}
      fullScreen={fullScreen}
    >
      <DialogTitle id='customized-dialog-title' onClose={handleClose}>
        <Typography variant='h6'>Remover cartão</Typography>
      </DialogTitle>
      <DialogContent className={classes.dialogContent} dividers>
        {loading && <Spin />}
        {cardNoUsage && (
          <Typography variant='body2' className={classes.noUsageText}>
            Tem certeza que deseja remover esse cartão? Essa ação não poderá ser desfeita!
          </Typography>
        )}
        {!loading && !!cardUsage.length && (
          <Fragment>
            <Typography variant='body2'>
              Este cartão está cadastrado no(s) contrato(s) abaixo. Para remover esse cartão você deve ir até o(s) contrato(s) informado(s) e alterar
              o cartão utilizado.
            </Typography>
            <CardUsageTable data={cardUsage} />
          </Fragment>
        )}
      </DialogContent>
      <DialogActions disableSpacing={false}>
        <div>
          <Button onClick={handleClose} className={classes.button}>
            Fechar
          </Button>
          {cardNoUsage && (
            <Button onClick={onRemove} variant='contained' className={classes.removeBtn} disabled={removing}>
              Remover cartão
            </Button>
          )}
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default DialogRemoveCard;
